import { useLocation } from '@reach/router';
import { useEffect } from 'react';
import { pushCustomEvent } from 'utils/analytics';

export function useOpenModalEventHandler(isOpen, label) {
  const currentLocation = useLocation();

  const handlePushEvent = () => {
    pushCustomEvent('ndrsn_open_modal_with_form', {
      action: 'open_modal',
      label,
      pageUrl: currentLocation?.href,
    });
  };

  useEffect(() => {
    if (isOpen) {
      handlePushEvent();
    }
  }, [isOpen]);
}
